import { render } from "./WigList.vue?vue&type=template&id=5152dc4b"
import script from "./WigList.vue?vue&type=script&lang=js"
export * from "./WigList.vue?vue&type=script&lang=js"

import "./WigList.vue?vue&type=style&index=0&id=5152dc4b&lang=css"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__